module.exports = __webpack_public_path__ + "img/berserker.a7f5a0c3.png";